import type { RouteContext } from './RouteContext';

export type RouteLogMetadata = {
    matchedPath: string;
    hasPathParameters: boolean;
    hasSearchParameters: boolean;
};

/**
 * Route values may contain authorization codes, tokens, or callback state.
 * Keep route logs useful without serializing any user-controlled values.
 */
export function buildRouteLogMetadata(route: RouteContext): RouteLogMetadata {
    return {
        matchedPath: route.matchedPath,
        hasPathParameters: Object.keys(route.pathParams).length > 0,
        hasSearchParameters: Object.keys(route.search).length > 0,
    };
}
